import { CallbackSinkNode, FrameChunkNode, FrameCloneNode, FrameDelayNode, FrameFilterNode, FrameFlattenNode, MemoryBufferNode, ObjectMergeNode, ReferenceSpaceConversionNode } from '../../nodes';
import { FrameDebounceNode } from '../../nodes/shapes/FrameDebounceNode';
import { ObjectFilterNode } from '../../nodes/shapes/ObjectFilterNode';
import { GraphShapeBuilder } from '../builders/GraphBuilder';
/**
 *
 */
export default function register() {
  GraphShapeBuilder.registerShape('convertToSpace', space => new ReferenceSpaceConversionNode(space, {
    inverse: false
  }));
  GraphShapeBuilder.registerShape('convertFromSpace', space => new ReferenceSpaceConversionNode(space, {
    inverse: true
  }));
  GraphShapeBuilder.registerShape('chunk', (size, timeout, timeoutUnit) => new FrameChunkNode(size, timeout, timeoutUnit));
  GraphShapeBuilder.registerShape('clone', () => new FrameCloneNode());
  GraphShapeBuilder.registerShape('debounce', (timeout, timeoutUnit) => new FrameDebounceNode(timeout, timeoutUnit));
  GraphShapeBuilder.registerShape('delay', (timeout, timeoutUnit) => new FrameDelayNode(timeout, timeoutUnit));
  GraphShapeBuilder.registerShape('filter', filterFn => new FrameFilterNode(filterFn));
  GraphShapeBuilder.registerShape('flatten', () => new FrameFlattenNode());
  GraphShapeBuilder.registerShape('buffer', () => new MemoryBufferNode());
  GraphShapeBuilder.registerShape('filterObjects', filterFn => new ObjectFilterNode(filterFn));
  GraphShapeBuilder.registerShape('store', () => new CallbackSinkNode());
  GraphShapeBuilder.registerShape('merge', (by, timeout, timeoutUnit) => new ObjectMergeNode(by, {
    timeout,
    timeoutUnit
  }));
}